import React, { useState } from 'react'
import { Box, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip, Typography, useTheme } from '@mui/material'
import dayjs from 'dayjs';
import { MdOutlineShoppingCart } from 'react-icons/md';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from "@mui/material";
import { httpsCallable } from 'firebase/functions';
import { functions } from '../../../../../Infrastructure/config';
import { useSelector } from 'react-redux';
import { refundsSx } from './styles';

export const Refunds = ({ refundsHistory }) => {
  const theme = useTheme()
    const [openErrorModal, setOpenErrorModal] = useState(false);
    const [modalErrorMessage, setModalErrorMessage] = useState("");
    const ip = useSelector((state) => state.ip.address)
    const page = useSelector((state)=> state.route.currentRoute)
     
    const handleVisitReceipt = async (chargeKey) => {
      const popup = window.open('', '_blank');
      if (!popup) {
        setModalErrorMessage("Pop-ups are blocked in your browser. Please enable pop-ups to view the receipt.");
        setOpenErrorModal(true);
        return;
      }
      try {
        const getReceiptUrl = httpsCallable(functions, "downloadclassreceipt");
        const { data } = await getReceiptUrl({ chargeKey, ip, page });
        if (data?.isSuccess) {
          popup.location = data?.url;
        } else {
          popup.close();
          setModalErrorMessage("Refund receipt isn't available");
          setOpenErrorModal(true);
        }
      } catch (error) {
        popup.close();
        setModalErrorMessage("An unexpected error occurred. Please try again later.");
        setOpenErrorModal(true);
      }
    }
  return (
    <>
        <Dialog
              open={openErrorModal}
              onClose={() => setOpenErrorModal(false)}
              PaperProps={{
                sx: refundsSx.dialogPaper,
              }}
            >
              <DialogTitle sx={refundsSx.dialogTitle}>
                Error
              </DialogTitle>
              <DialogContent>
                <Box sx={refundsSx.dialogContentBox}>
                  <Typography color="text.secondary">
                    {modalErrorMessage}
                  </Typography>
                </Box>
              </DialogContent>
              <DialogActions sx={refundsSx.dialogActions}>
                <Button
                  onClick={() => setOpenErrorModal(false)}
                  variant="contained"
                  sx={refundsSx.closeButton}
                >
                  Close
                </Button>
              </DialogActions>
        </Dialog>
      {refundsHistory && refundsHistory?.length > 0 ? (
        <Box>
          <Box>
            <TableContainer component={Paper}>
              <Table sx={refundsSx.table} size="small" aria-label="a dense table">
                <TableHead>
                  <TableRow>
                    <TableCell sx={refundsSx.tableHeadCell}>Course Title</TableCell>
                    <TableCell sx={refundsSx.tableHeadCell}>Class</TableCell>
                    <TableCell sx={refundsSx.tableHeadCell}>Time</TableCell>
                    <TableCell sx={refundsSx.tableHeadCell}>Date</TableCell>
                    <TableCell sx={refundsSx.tableHeadCellPrice}>Total Price</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {refundsHistory?.map((refund, index) => (
                    <TableRow key={index}>
                      <TableCell sx={refundsSx.tableRowCell} align="left">
                        <Box sx={refundsSx.courseBox}>
                          <Box sx={refundsSx.iconBox}>
                            <MdOutlineShoppingCart size={22} />
                          </Box>
                          <Tooltip
                            title={refund?.metadata?.course_title}
                            placement="top"
                            enterTouchDelay={0}
                          >
                            <Typography
                              sx={{...refundsSx.courseTitle, color: theme.palette.primary.main}}
                              onClick={() => handleVisitReceipt(refund?.charge)}
                            >
                              {refund?.metadata?.course_title}
                            </Typography>
                          </Tooltip>
                        </Box>
                      </TableCell>
                      <TableCell sx={refundsSx.tableRowCell} align="left">{refund?.metadata?.cohort_id}</TableCell>
                      <TableCell sx={refundsSx.tableRowCell} align="left">{dayjs.unix(refund?.created).format('hh:mm A')}</TableCell>
                      <TableCell sx={refundsSx.tableRowCell} align="left">{dayjs.unix(refund?.created).format('MM/DD/YYYY')}</TableCell>
                      <TableCell sx={refundsSx.tableRowCell} align="left">${(refund?.amount / 100).toFixed(2)}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        </Box>
      ) : (
        <Typography variant="body1">No refunds</Typography>
      )}
    </>
  )
}
